import { render } from "./TestLectureForm.vue?vue&type=template&id=f85384fa&scoped=true"
import script from "./TestLectureForm.vue?vue&type=script&lang=js"
export * from "./TestLectureForm.vue?vue&type=script&lang=js"

import "./TestLectureForm.vue?vue&type=style&index=0&id=f85384fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85384fa"]])

export default __exports__